// extracted by mini-css-extract-plugin
export default {"informationList":"VehicleInformation_informationList__KAktC"};